export default __webpack_public_path__ + "static/media/help.48ea764b.png";